<listview
    #listView
    [config]="config"
    class="page-layout simple left-sidebar inner-sidebar inner-scroll"
    (onTooolbarButtonClick)="toolbarButtonHandler($event)"
>
</listview>
